module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "150px"
    }
  }, [_vm._v("I would also like to express my gratitude to the following sources for providing me with the images for my book cover.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Front cover photographs clockwise from top:")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("Fagan children with their father.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Anne Frank—photo courtesy of Anne Frank House, Amsterdam.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The Evacuation of Jews—photo courtesy of Truman Library, Independence, Missouri, USA.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The Old Coombe Hospital, Dublin. Drawing by Michael O’Brien from Me Jewel and Darlin’ Dublin by Éamonn MacThomáis, published by The O’Brien Press Ltd. Copyright © the estate of Michael O’Brien.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258a58b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0